import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
    loading: true,
    dashboardData: {}
}

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        getDashboardData: (state, action) => {
            state.loading = true
        },
        dashboardDataSuccess: (state, action) => {
            state.dashboardData = action.payload
            state.loading = false
        },
        dashboardDataFailed: (state, action) => {
            state.loading = false
        }
    }
});

export const {
    getDashboardData,
    dashboardDataSuccess,
    dashboardDataFailed
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
